import { ReactElement } from 'react';

const ToastWrapper = (message: string, dataCy: string): ReactElement => {
  return <div data-cy={dataCy}>{message}</div>;
};

export default ToastWrapper;
